import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Freelancers = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="64" viewBox="0 0 74 64" width="74" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M68.66 16.16v36.47c0 1.4-.96 2.7-2.33 3.06a101.5 101.5 0 0 1-52.54 0 3.2 3.2 0 0 1-2.33-3.06V16.5c0-.93 1.07-1.4 1.77-.77l3.43 3.24 6.71-6.3a3.14 3.14 0 0 1 4.28-.04l5.09 4.65 4.98-4.5a3.1 3.1 0 0 1 4.42.22l4.87 5.38 7.6-6.08a3.1 3.1 0 0 1 3.98.07l5.72 4.94 2.7-1.99c.65-.51 1.65 0 1.65.85Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M63.2 9.56v36.47c0 1.4-.97 2.7-2.33 3.06a101.5 101.5 0 0 1-52.55 0A3.2 3.2 0 0 1 6 46.03V9.9c0-.93 1.07-1.4 1.77-.78l3.43 3.25 4.82 4.5a3.14 3.14 0 0 0 4.25.07l7-6.26 4.99-4.5a3.1 3.1 0 0 1 4.42.22l4.87 5.38 4.46 4.94a3.1 3.1 0 0 0 4.2.4l8.63-6.41 2.7-1.99c.65-.51 1.65 0 1.65.85Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m27.28 10.67-7 6.27a3.1 3.1 0 0 1-4.25-.08l-4.83-4.5 6.72-6.3a3.14 3.14 0 0 1 4.28-.04z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m58.85 10.7-8.63 6.42a3.1 3.1 0 0 1-4.2-.4l-4.46-4.95 7.6-6.08a3.1 3.1 0 0 1 3.98.07z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path d="M43.64 28.95V41h-6.02v-6.03h-6.03V41h-6.02V28.95z" fill={shades.black} />
    </svg>
  );
};
